/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_3_P1Inputs */

const en_terms_section_3_p1 = /** @type {(inputs: Terms_Section_3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo builds AI systems and automation for small businesses: assistants that answer from your own documents, workflows that connect the tools you already use, and internal tools your team runs the work in. We also take on related software development and consulting.`)
};

const lv_terms_section_3_p1 = /** @type {(inputs: Terms_Section_3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo veido AI sistēmas un automatizāciju maziem uzņēmumiem: asistentus, kas atbild no Jūsu pašu dokumentiem, darba plūsmas, kas savieno jau lietotos rīkus, un iekšējos rīkus, kuros komanda dara darbu. Uzņemamies arī ar to saistītu programmatūras izstrādi un konsultācijas.`)
};

/**
* | output |
* | --- |
* | "Lindevo builds AI systems and automation for small businesses: assistants that answer from your own documents, workflows that connect the tools you already u..." |
*
* @param {Terms_Section_3_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_3_p1 = /** @type {((inputs?: Terms_Section_3_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_3_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_3_p1(inputs)
	return en_terms_section_3_p1(inputs)
});